// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__2TTKM","menuItem":"Menu_menuItem__2SSmB","active":"Menu_active__1zRw9","searchInput":"Menu_searchInput__1E5Xu"};